import useUser from '@/hooks/user';
import { Group } from '@/types/core/Group';
import { useMemo } from 'react';
import isGranted from '@/components/app/users/isGranted';

interface UseGroupReturn {
  isMember: boolean;
  canEdit: boolean;
  canShow: boolean;
}

export function useGroup(group: Group | null): UseGroupReturn {
  return {
    isMember: useIsMemberGroup(group),
    canEdit: useCanEditGroup(group),
    canShow: useCanShowGroup(group),
  };
}

export function useIsMemberGroup(group: Group | null): boolean {
  const user = useUser();

  return useMemo(() => {
    return user && group?.isMember;
  }, [user, group?.isMember]);
}

export function useCanEditGroup(group: Group | null): boolean {
  const user = useUser();

  return useMemo(() => {
    if (!user) {
      return false;
    }
    return (
      user.id === group?.admin?.id ||
      isGranted(user, 'ROLE_WORLD_ORGANISER') ||
      (isGranted(user, 'ROLE_COUNTRY_ORGANISER') &&
        group?.country?.id === user.country.id)
    );
  }, [user, group]);
}

export function useCanShowGroup(group: Group | null): boolean {
  const isMember = useIsMemberGroup(group);

  return useMemo(() => {
    return isMember || !group?.private;
  }, [isMember, group?.private]);
}
